import React from 'react'
import { reduxForm, Field, SubmissionError } from 'redux-form'
import css from './style.css'
import { login as apiLogin } from '../../api/session'
import { loginSuccess } from '../../actions/current-user'
import Label from '../../components/label'
import Input from '../../components/input'
import Button from '../../components/button'
import Spacer from '../../components/spacer'

const renderInput = ({input, type, placeholder, meta: {touched, error}}) =>
  <div>
    <Input {...input} type={type} placeholder={placeholder} touched={touched} error={error} pad />
  </div>

const LoginForm = props => {
  const { error, handleSubmit, submitting, pristine, invalid } = props
  const submit = (data) => {
    return apiLogin(data)
      .catch(e => {
        throw new SubmissionError({ _error: e.response.data.errors })
      })
  }

  return (
    <div className={css.container}>
      <form onSubmit={handleSubmit(submit)}>
        <Label>Email</Label>
        <Field name='email' placeholder='Email' component={renderInput} />
        <Label>Password</Label>
        <Field name='password' placeholder='Password' type='password' component={renderInput} />
        <div className={css.error}>{error}</div>
        <Spacer xs />
        <Button disabled={pristine || submitting || invalid}
          center
          onClick={handleSubmit(submit)}>
          Login
        </Button>
      </form>
    </div>
  )
}

const validate = (values, props) => {
  const errors = {}
  if (!values.email) {
    errors.email = 'Required.'
  } else if (!values.password) {
    errors.password = 'Required'
  }
  return errors
}

export default reduxForm({
  form: 'login',
  validate,
  onSubmitSuccess: (result, dispatch) => {
    dispatch(loginSuccess(result.data))
  }
})(LoginForm)



// WEBPACK FOOTER //
// ./src/containers/login/form.js